module.exports = __webpack_public_path__ + "static/media/empty.05890715.svg";